import axios from './axios';
import auth from '../resources/Auth';

export default {
  get: async (page = 1, perPage = 20) => {
    const url = `${process.env.REACT_APP_API_URL}/chat`;
    return await axios.get(url, {
      params: { page, per_page: perPage },
      headers: { Authorization: `Bearer ${auth.token}` },
    });
  },

  unreadCount: async () => {
    const url = `${process.env.REACT_APP_API_URL}/chat/unreadCount`;
    return await axios.get(url, {
      headers: { Authorization: `Bearer ${auth.token}` },
    });
  },

  markRead: async (ids = [], all = false) => {
    const url = `${process.env.REACT_APP_API_URL}/chat/markRead`;
    return await axios.post(url, all ? { all: true } : { ids }, {
      headers: { Authorization: `Bearer ${auth.token}` },
    });
  },

  send: async (content) => {
    const url = `${process.env.REACT_APP_API_URL}/chat/send`;
    return await axios.post(
      url,
      { content },
      {
        headers: { Authorization: `Bearer ${auth.token}` },
      }
    );
  },

  delete: async (id) => {
    const url = `${process.env.REACT_APP_API_URL}/chat/${id}`;
    return await axios.delete(url, {
      headers: { Authorization: `Bearer ${auth.token}` },
    });
  },
};
